import styled from 'styled-components';

export const AlimtalkSendCreateWrapStyle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 8px 4px 80px;
`;

export const Section = styled.section`
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 20px 24px;
`;

export const SectionTitle = styled.div`
  font-size: 15px;
  font-weight: 600;
  color: #111827;
  margin-bottom: 16px;
`;

/** 제목 + 우측 액션 버튼을 한 줄에 배치 (내부 SectionTitle의 기본 margin 제거) */
export const SectionTitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;

  ${SectionTitle} {
    margin-bottom: 0;
  }
`;

export const Hint = styled.div`
  font-size: 12px;
  color: #6b7280;
  margin-top: 8px;
`;

export const SelectorCaption = styled.div`
  font-size: 12px;
  color: #9ca3af;
  margin-bottom: 14px;
`;

export const GuideCenter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 32px 24px;
`;

export const GuideTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #374151;
`;

export const GuideSub = styled.div`
  font-size: 12px;
  color: #9ca3af;
`;

export const Status = styled.div`
  font-size: 12px;
  color: #10b981;
  margin-top: 8px;
`;

export const TypeGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 8px;
`;

// div가 아닌 button — Tab 포커스·Enter/Space 활성화가 기본 제공되어야 키보드만으로 유형 선택을 마칠 수 있다
export const TypeCard = styled.button<{ $selected: boolean }>`
  display: block;
  width: 100%;
  text-align: left;
  font: inherit;
  border: 1.5px solid ${({ $selected }) => ($selected ? '#2563eb' : '#e2e8f0')};
  background: ${({ $selected }) => ($selected ? '#eff6ff' : '#fff')};
  border-radius: 8px;
  padding: 12px 14px;
  cursor: pointer;
  transition:
    border 0.12s,
    background 0.12s;

  &:hover {
    border-color: #93c5fd;
  }

  &:focus-visible {
    outline: 2px solid #2563eb;
    outline-offset: 2px;
  }
`;

export const TypeName = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 4px;
`;

export const TypeDesc = styled.div`
  font-size: 11px;
  color: #9ca3af;
`;

export const FieldRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  & + & {
    margin-top: 16px;
  }
`;

export const FieldLabel = styled.label`
  font-size: 12px;
  font-weight: 600;
  color: #374151;
`;

export const ActionBar = styled.div`
  position: sticky;
  bottom: 0;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  background: #fff;
  border-top: 1px solid #e2e8f0;
  padding: 12px 0;
`;

/* ── 쿠폰/기획전 선택 목록 ── */
export const SelectedList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 12px;
`;

export const SelectedRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 8px 10px;
`;

export const SelectedName = styled.span`
  flex: 1;
  font-size: 13px;
  color: #1f2937;
`;

export const IdBadge = styled.span`
  color: #9ca3af;
  font-size: 11px;
`;

export const UploadingStatus = styled.div`
  font-size: 12px;
  color: #f59e0b;
  margin-top: 8px;
`;

export const PriorityIndex = styled.span`
  width: 20px;
  font-size: 11px;
  font-weight: 700;
  color: #6b7280;
  text-align: center;
`;

export const EmptyText = styled.div`
  font-size: 12px;
  color: #9ca3af;
  padding: 8px 0;
`;

/* ── 카카오 알림톡 미리보기 (BizM 형태) ── */
export const KakaoBubble = styled.div`
  width: 300px;
  max-width: 100%;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);
`;

export const KakaoHeader = styled.div`
  background: #fae100;
  color: #3c1e1e;
  padding: 11px 16px;
  font-size: 13px;
  font-weight: 700;
`;

export const KakaoContent = styled.div`
  padding: 16px;
`;

export const KakaoBody = styled.div`
  font-size: 13.5px;
  color: #2d2d2d;
  line-height: 1.75;
  white-space: pre-line;
`;

export const KakaoButtonGroup = styled.div`
  border-top: 1px solid #f0f0f0;
`;

export const KakaoButton = styled.div`
  width: 100%;
  padding: 12px;
  text-align: center;
  font-size: 13.5px;
  color: #3d3d3d;
  background: #fff;

  & + & {
    border-top: 1px solid #f0f0f0;
  }
`;

export const KakaoNoAlimtalk = styled.div`
  text-align: center;
  padding: 16px 12px;
  color: #64748b;
  font-size: 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
`;

/* ── 피커 모달 ── */
export const PickerSearchRow = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
`;

export const PickerList = styled.div`
  max-height: 360px;
  overflow-y: auto;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
`;

export const PickerRow = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 12px;
  border-bottom: 1px solid #f1f5f9;
  cursor: pointer;
  font-size: 13px;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: #f8fafc;
  }
`;

/* ── 등록 전 preview 확인 모달 ── */
export const PreviewStatRow = styled.div`
  display: flex;
  gap: 24px;
  padding: 12px 14px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
`;

export const PreviewStat = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const PreviewStatLabel = styled.span`
  font-size: 12px;
  color: #6b7280;
`;

export const PreviewStatValue = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: #111827;
`;

export const PreviewMessageBox = styled.div`
  padding: 12px 14px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 13px;
  color: #2d2d2d;
  line-height: 1.7;
  white-space: pre-line;
  max-height: 240px;
  overflow-y: auto;
`;

export const PreviewErrorBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 14px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 8px;
  font-size: 13px;
  color: #b91c1c;
  line-height: 1.6;
`;

/** 필수 입력 표시 — 백엔드 DTO 필수(또는 유형 조건부 필수) 필드 라벨에 부착 */
export const RequiredMark = styled.span`
  color: #ef4444;
  margin-left: 2px;
`;
